import api from '@/api/api';
import { createQueryParams } from '@/utils/createQueryParams';

const DOMAIN = '/patients';

const get = async (
	params?: Patients.PatientParams,
): Promise<Patients.GetPatientsResponse> => {
	const queryParams = createQueryParams({ ...(params ?? {}) });
	const { data } = await api.get(`${DOMAIN}?${queryParams}`);
	return data;
};

const getById = async (id: string): Promise<Patients.Patient> => {
	const { data } = await api.get(`${DOMAIN}/${id}`);
	return data;
};

const create = async (
	body: Patients.Create,
	professionalId?: string,
): Promise<Patients.Patient> => {
	const queryParams = professionalId
		? createQueryParams({ professional_id: professionalId })
		: null;
	const suffix = queryParams?.toString() ? `?${queryParams.toString()}` : '';
	const { data } = await api.post(`${DOMAIN}${suffix}`, body);
	return data;
};

const patch = async (
	id: string,
	body: Patients.Update,
): Promise<Patients.Patient> => {
	const { data } = await api.patch(`${DOMAIN}/${id}`, body);
	return data;
};

const remove = async (id: string): Promise<void> => {
	await api.delete(`${DOMAIN}/${id}`);
};

const PatientService = {
	get,
	getById,
	create,
	patch,
	remove,
};

export { PatientService };
